const errorMapper = (errorCode, t) => {
  switch (errorCode) {
    case 'ERROR_INVALID_CREDENTIALS':
    case 'ERROR_USER_NOT_FOUND':
    case 'ERROR_NOT_VALID_PHONE_NUMBER':
    case 'ERROR_COMPANY_CODE_NOT_FOUND':
      return t('Login.IncorrectUsernameOrPassword');
    case 'INTERNAL_SERVER_ERROR':
      return t('Login.InternalServerError');
    default:
      return t('Login.UnknownError');
  }
};

export default errorMapper;
